<template>
  <transition name="fade">
    <div class="loader"></div>
  </transition>
</template>

<script>
export default {
  data() {

  },
  props: {
    color: {
      type: String,
      default: 'white',
    },
    transparency: {
      type: Number,
      default: 0.7,
    },
    isBody: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  mounted() {},
  beforeDestroy() {
    gavlegardarna.loader.hide(this.loader, true);
  },
};
</script>
